<template>
  <div class="bg-white shadow-md relative rounded-lg p-8">
    <el-dialog title="" :visible.sync="addAlbum" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Add Album</h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium mb-2"
              >Album Name</small
            >
            <el-form-item prop="name" class="">
              <el-input
                @input="handleUpperCase"
                placeholder="Please input"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3 pt-2">
            <small class="fsize12 bg-white text-dark font-medium mb-2"
              >Categories</small
            >

            <el-form-item prop="categoriesIds" class="">
              <el-select
                multiple
                v-model="ruleForm.categoriesIds"
                placeholder="Please Select Categories"
                class=""
              >
                <el-option
                  v-for="category in categoriesOption"
                  :key="category._id"
                  :label="category.name"
                  :value="category._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Cover photo</small
            >
            <p class="fsize10 bg-white text-light font-medium mb-4">
              Recommended Image Size:
              <span class="font-semibold">405 x 530 </span><br />Maximum File
              size: <span class="font-semibold">5mb</span>
            </p>
            <!-- <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload> -->
            <FileUpload
              v-if="image == null"
              :image="image"
              :onSuccess="handleSuccess"
              class="m-auto"
            />

            <div v-else class="relative">
              <img
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="object-cover imgpre"
              />

              <div
                class="absolute top-0 right-0 bg-white rounded-full p-1"
                v-if="image"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="handleRemove"
                />
              </div>
            </div>
          </div>
          <!-- <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Gallery</small
            >
            <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload>
          </div> -->
          <div class="mt-6">
            <small class="fsize14 font-semibold text-4f4f4f mb-0"
              >Gallery</small
            >
            <p class="fsize10 bg-white text-light font-medium mb-4">
              Recommended Image Size:
              <span class="font-semibold">405 x 530 </span><br />Maximum File
              size: <span class="font-semibold">20mb</span>
            </p>
            <el-upload
              v-if="datavalue.length == 0"
              class="upload-demo mt-1 category-uploader"
              multiple
              action="#"
              drag
              :before-upload="multipleimages"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <div class="mt-4">
                  <p class="fsize16">Drop file or click here to upload or</p>
                  <p class="text-primary fsize16">Browse</p>
                </div>
              </div>
            </el-upload>
            <div class="mt-6 grid grid-cols-4 gap-2">
              <div
                v-for="(image, index) in renderedmultipleImage"
                :draggable="true"
                @dragstart="handleDragStart(index, $event)"
                @dragover="handleDragOver(index, $event)"
                @drop="handleDrop(index)"
                class="relative draggable-item"
                :key="`${image} + ${index}`"
              >
                <img
                  :src="image"
                  class="rounded-4px object-cover w-full imgpre h-24"
                />

                <div
                  class="absolute top-0 xiconset right-0 bg-white rounded-full p-1"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer flex"
                    @click="
                      () => {
                        datavalue.splice(index, 1);
                        renderedmultipleImage.splice(index, 1);
                      }
                    "
                  />
                </div>
              </div>
              <el-upload
                v-if="datavalue.length > 0"
                class="rounded-4px w-full imgpre h-24 custh24"
                multiple
                action="#"
                drag
                :before-upload="multipleimages"
                accept="image/*"
              >
                <i class="el-icon-upload custuploadicon"></i>
              </el-upload>
            </div>
          </div>
          <!-- <div class="grid grid-cols-3">
            <div class="relative">
              <img
                src="@/assets/images/banh.png"
                class="w-full h-24"
                alt="banh"
              />
              <div class="absolute top-0 right-0 mt-2 mr-2">
                <feather-icon icon="XIcon" class="" svgClasses="w-4 h-4" />
              </div>
            </div>
          </div> -->
          <div class="grid grid-cols-2 gap-4 mt-6">
            <vs-button
              type="primary"
              class="bg-primary rounded-full font-semibold py-5 fsize14"
              @click.prevent="handleSubmit('ruleForm', 'Add')"
              >Save</vs-button
            >

            <vs-button
              type="secondary"
              class="bg-secondary rounded-full font-semibold py-5 fsize14"
              @click="handleClose('Add')"
              >Cancel</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="" :visible.sync="editAlbum" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">Edit Album</h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Album Name</small
            >
            <el-form-item prop="name" class="">
              <el-input
                @input="handleUpperCase"
                placeholder="Please input"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3 pt-2">
            <small class="fsize12 bg-white text-dark font-medium"
              >Categories</small
            >

            <el-form-item prop="categoriesIds" class="">
              <el-select
                multiple
                v-model="ruleForm.categoriesIds"
                placeholder="Please Select Categories"
                class=""
              >
                <el-option
                  v-for="category in categoriesOption"
                  :key="category._id"
                  :label="category.name"
                  :value="category._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Cover photo</small
            >
            <p class="fsize10 bg-white text-light font-medium mb-4">
              Recommended Image Size:
              <span class="font-semibold">405 x 530 </span><br />Maximum File
              size: <span class="font-semibold">5mb</span>
            </p>
            <!-- <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload> -->
            <FileUpload
              v-if="image == null"
              :image="image"
              :onSuccess="handleSuccess"
              class="m-auto"
            />

            <div v-else class="relative">
              <img
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="object-cover imgpre"
              />

              <div
                class="absolute top-0 right-0 bg-white rounded-full p-1"
                v-if="image"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="handleRemove"
                />
              </div>
            </div>
          </div>
          <!-- <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Gallery</small
            >
            <el-upload
              class="upload-demo"
              drag
              action="https://jsonplaceholder.typicode.com/posts/"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload>
          </div> -->
          <div class="mt-6">
            <small class="fsize14 font-semibold text-4f4f4f mb-0"
              >Gallery</small
            >
            <p class="fsize10 bg-white text-light font-medium mb-4">
              Recommended Image Size:
              <span class="font-semibold">405 x 530 </span><br />Maximum File
              size: <span class="font-semibold">20mb</span>
            </p>
            <el-upload
              v-if="datavalue.length == 0"
              class="upload-demo mt-1 category-uploader"
              multiple
              action="#"
              drag
              :before-upload="multipleimages"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <div class="mt-4">
                  <p class="fsize16">Drop file or click here to upload or</p>
                  <p class="text-primary fsize16">Browse</p>
                </div>
              </div>
            </el-upload>
            <div class="mt-6 grid grid-cols-4 gap-2">
              <div
                v-for="(image, index) in renderedmultipleImage"
                :draggable="true"
                @dragstart="handleDragStart(index, $event)"
                @dragover="handleDragOver(index, $event)"
                @drop="handleDrop(index)"
                class="relative draggable-item"
                :key="`${image} + ${index}`"
              >
                <img
                  :src="image"
                  class="rounded-4px object-cover w-full imgpre h-24"
                />

                <div
                  class="absolute top-0 xiconset right-0 bg-white rounded-full p-1"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer flex"
                    @click="
                      () => {
                        datavalue.splice(index, 1);
                        renderedmultipleImage.splice(index, 1);
                      }
                    "
                  />
                </div>
              </div>
              <el-upload
                v-if="datavalue.length > 0"
                class="rounded-4px w-full imgpre h-24 custh24"
                multiple
                action="#"
                drag
                :before-upload="multipleimages"
                accept="image/*"
              >
                <i class="el-icon-upload custuploadicon"></i>
              </el-upload>
            </div>
          </div>
          <!-- <div class="grid grid-cols-3">
            <div class="relative">
              <img
                src="@/assets/images/banh.png"
                class="w-full h-24"
                alt="banh"
              />
              <div class="absolute top-0 right-0 mt-2 mr-2">
                <feather-icon icon="XIcon" class="" svgClasses="w-4 h-4" />
              </div>
            </div>
          </div> -->
          <div class="grid grid-cols-2 gap-4 mt-6">
            <vs-button
              type="primary"
              class="bg-primary rounded-full font-semibold py-5 fsize14"
              @click.prevent="handleSubmit('ruleForm', 'Edit')"
              >Save</vs-button
            >

            <vs-button
              type="secondary"
              class="bg-secondary rounded-full font-semibold py-5 fsize14"
              @click="handleClose('Edit')"
              >Cancel</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex w-full justify-between items-center">
      <div class="w-4/5">
        <div class="relative">
          <el-input
            placeholder="Please input"
            v-model="search"
            class="rounded-none w-full"
          ></el-input>
          <div class="absolute top-0 right-0 mt-2 mr-2">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
      </div>
      <div class="w-1/5 flex justify-end">
        <vs-button
          color="primary"
          @click="openDialog('Add')"
          class="bg-primary px-8"
          >Add Album</vs-button
        >
      </div>
    </div>
    <div class="w-full">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          prop="subcategoryId"
          label="Category Name"
          min-width="50px"
        >
          <template v-slot="{ row }">
            <P class="text-gray">
              {{
                row.categoryId &&
                Array.isArray(row.categoryId) &&
                row.categoryId.length > 0
                  ? renderCategory(row.categoryId)
                  : row.categoryId.name
              }}
            </P>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Album Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.name }}</P>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <!-- <feather-icon
                icon="EyeIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              /> -->
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="openDialog('Edit', row)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="deletePopup(row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full flex justify-end mt-6" v-if="totalRows">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="totalRows"
        :page-size="perPage"
        @current-change="setPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import FileUpload from "@/components/FileUpload.vue";
import { mapState } from "vuex";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",

      tableData: [],

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      subcategoryId: "",
      addAlbum: false,
      editAlbum: false,
      categoriesOption: [],

      ruleForm: {
        name: "",
        categoriesIds: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please Enter Album Name",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9\-./ ]*$/,
            message:
              "Only Alpha Numeric, Hyphen(-), Slash(/), FullStop(.) are Allowed",
            trigger: "blur",
          },
        ],
        categoriesIds: [
          {
            type: "array",
            required: true,
            message: "Please Select Categories",
            trigger: ["blur", "change"],
          },
        ],
      },

      image: null,
      coverImage: null,

      datavalue: [],
      draggedIndex: null,
      counter: 1,
      renderedmultipleImage: [],
    };
  },
  components: {
    FileUpload,
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("baseAdminCategory", {
      subcategory: "subcategory",
    }),
    ...mapState("baseAdminCategory", {
      selectedCategory: "selectedCategory",
    }),
  },
  watch: {
    async currentPage() {
      await this.getSubcategory();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getSubcategory();
      }, 500),
    },
  },
  methods: {
    handleUpperCase(value) {
      // this.ruleForm.name = value.toUpperCase();
      this.ruleForm.name = value;
    },
    handleDragStart(index, event) {
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", index);
    },
    handleDragOver(index, event) {
      event.preventDefault();
    },
    handleDrop(index) {
      const draggedImage = this.renderedmultipleImage[this.draggedIndex];
      this.renderedmultipleImage.splice(this.draggedIndex, 1);
      this.renderedmultipleImage.splice(index, 0, draggedImage);

      const draggedImageData = this.datavalue[this.draggedIndex];
      this.datavalue.splice(this.draggedIndex, 1);
      this.datavalue.splice(index, 0, draggedImageData);
    },
    handleDragEnd() {
      this.draggedIndex = null;
    },
    async multipleimages(file) {
      // console.log(file.target.files,"khk");
      // console.log(file);
      // console.log(this.datavalue);
      // if (this.datavalue.length < 10) {
      this.datavalue.push(file);
      // } else {
      //   // this.datavalue.shift(file);
      //   return await this.$swal({
      //     title: `Only 10 Images are Allowed!`,
      //     type: "error",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      // }
      console.log(this.datavalue.length);
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // if (this.renderedmultipleImage.length < 10) {
        this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        // } else {
        //   // this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        // }
      };
      reader.readAsDataURL(rawFile);
    },
    async readFile(file) {
      let self = this;
      let result = await new Promise((resolve) => {
        if (file) {
          let reader = new FileReader();
          let fileName = file.name.split(".");
          reader.onload = async function (event) {
            var renamedFile = new File(
              [event.target.result],
              `${self.counter}.${fileName[fileName.length - 1]}`,
              { type: file.type }
            );
            console.log(self.counter);
            self.counter++;
            resolve(renamedFile);
            console.log(renamedFile);
          };
          reader.readAsArrayBuffer(file);
        }
      });
      return result;
    },
    async getImageMetadata(imageUrl) {
      let raw = await fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const file = new File([blob], "image", { type: blob.type });
          return file;
        })
        .catch((error) => {
          console.error("Error fetching the image:", error);
        });
      return raw;
    },
    renderCategory(categoryId) {
      let catArray = categoryId.map((cat) => cat.name);
      return catArray.toString();
    },

    async openDialog(action, data = {}) {
      this.resetForm();
      if (action === "Edit") {
        this.addAlbum = false;
        let categoryIdArray = [];
        if (Array.isArray(data.categoryId)) {
          categoryIdArray = data.categoryId.map((cat) => {
            return cat._id;
          });
          console.log(categoryIdArray);
        }
        this.ruleForm.categoriesIds = Array.isArray(data.categoryId)
          ? categoryIdArray
          : [data.categoryId._id];

        console.log();
        this.editAlbum = true;
        this.ruleForm.name = data.name ? data.name : "";
        this.image = data.image ? data.image : "";
        this.subcategoryId = data._id ? data._id : "";
        if (data.album && data.album.length > 0) {
          let imagesData = data.album.map(async (img, index) => {
            let imageFile = await this.getImageMetadata(this.getImage(img));
            // console.log(imageFile);
            this.newHandlemultiple(imageFile);
            return imageFile;
          });

          let rawData = await Promise.all(imagesData);

          this.datavalue = data.album ? rawData : [];
        }
      } else if (action === "Add") {
        this.editAlbum = false;
        this.addAlbum = true;
      }
    },
    handleSubmit(formName, action) {
      this.ruleForm.name = this.ruleForm.name.trim();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (action === "Add") {
            this.onAddSubmit();
          } else if (action === "Edit") {
            this.onEditSubmit();
          }
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    getImage(img) {
      return `${process.env.VUE_APP_IMAGE_URL}/${img}`;
    },
    resetForm() {
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm.name = "";
      this.image = null;
      this.coverImage = null;
      this.subcategoryId = "";
      this.datavalue = [];
      this.draggedIndex = null;
      this.counter = 1;
      this.renderedmultipleImage = [];
      this.ruleForm.categoriesIds = [];
      // this.categoriesOption = [];
    },
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async deletePopup(subcategoryId) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#cd3197",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(subcategoryId);
        }
      });
    },
    async handleDelete(subcategoryId) {
      let payload = {
        subcategoryId: subcategoryId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch(
        "baseAdminCategory/deleteSubCategoryData",
        payload
      );
      this.currentPage = 1;
      this.getSubcategory();
    },
    async onAddSubmit() {
      const payload = new FormData();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Upload Cover Photo!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }
      if (this.datavalue.length === 0) {
        this.$swal.fire({
          text: "Please Upload Gallery Photo!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }

      payload.append("name", this.ruleForm.name);
      if (this.coverImage) {
        payload.append("image", this.coverImage);
      }
      // payload.append("categoryId", this.selectedCategory._id);
      payload.append("categoryId", JSON.stringify(this.ruleForm.categoriesIds));
      payload.append("isAdmin", true);
      payload.append("adminId", this.login._id);

      for (let i in this.datavalue) {
        // payload.append("productImage", this.datavalue[i]);
        // console.log(this.datavalue[i].name);
        let file = this.datavalue[i];
        let data = await this.readFile(file);
        console.log(data);
        payload.append("album", data);
        // console.log(this.datavalue[i].name);
      }

      let loader;
      try {
        console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        const createSubcategory = await this.$store.dispatch(
          "baseAdminCategory/addSubCategoryData",
          payload
        );

        if (createSubcategory.code === 200) {
          // edit category data
          console.log(this.ruleForm.categoriesIds[0], "ID");
          // let newpayload = new FormData();
          let updatePayload = {
            categoryId: this.ruleForm.categoriesIds[0],
            isAddSubCategory: false,
          };
          // newpayload.append("categoryId", this.ruleForm.categoriesIds[0]);
          // newpayload.append("isAddSubCategory", false);
          const updateCategory = await this.$store.dispatch(
            "baseAdminCategory/editCategoryData",
            updatePayload
          );
          console.log(updateCategory);
          // console.log(createSubcategory);
          loader.close();
          this.handleClose("Add");
          await this.$swal({
            title: "Album Created Successfully!",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.ruleForm.name = "";
          this.image = null;
          this.coverImage = null;
          this.datavalue = [];
          this.counter = 1;
          this.renderedmultipleImage = [];
          this.draggedIndex = null;
          this.$refs["ruleForm"].resetFields();
          this.getSubcategory();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async onEditSubmit() {
      const payload = new FormData();

      if (!this.coverImage && !this.image) {
        this.$swal.fire({
          text: "Please Upload Cover Photo!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }
      if (this.datavalue.length === 0) {
        this.$swal.fire({
          text: "Please Upload Gallery Photo!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }

      payload.append("name", this.ruleForm.name);
      if (this.coverImage) {
        payload.append("image", this.coverImage);
      }
      payload.append("categoryId", JSON.stringify(this.ruleForm.categoriesIds));
      payload.append("subcategoryId", this.subcategoryId);
      payload.append("isAdmin", true);
      payload.append("adminId", this.login._id);

      for (let i in this.datavalue) {
        // payload.append("productImage", this.datavalue[i]);
        // console.log(this.datavalue[i].name);
        let file = this.datavalue[i];
        let data = await this.readFile(file);
        console.log(data);
        payload.append("album", data);
        // console.log(this.datavalue[i].name);
      }

      let loader;
      try {
        console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        const updateSubcategory = await this.$store.dispatch(
          "baseAdminCategory/editSubCategoryData",
          payload
        );

        if (updateSubcategory.code === 200) {
          // console.log(updateSubcategory);
          loader.close();
          this.handleClose("Edit");
          await this.$swal({
            title: "Album Updated Successfully!",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.ruleForm.name = "";
          this.image = null;
          this.coverImage = null;
          this.datavalue = [];
          this.counter = 1;
          this.renderedmultipleImage = [];
          this.draggedIndex = null;
          this.$refs["ruleForm"].resetFields();
          this.getSubcategory();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async getSubcategory() {
      let curPage = this.currentPage - 1;
      console.log(this.selectedCategory);
      let payload = {
        limit: this.perPage,
        offset: curPage,
        categoryId: this.selectedCategory._id,
        // categoryId: "test",
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getSubcategory = await this.$store.dispatch(
          "baseAdminCategory/getSubCategoryData",
          payload
        );
        // console.log(getSubcategory);
        loader.close();
        if (getSubcategory.code === 200) {
          this.totalRows = this.subcategory.totalCount;
          this.tableData = this.subcategory.result;
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
    handleClose(action) {
      if (action === "Add") {
        this.addAlbum = false;
      } else if (action === "Edit") {
        this.editAlbum = false;
      }
    },
    openAddAlbumPopup() {
      console.log("add Album popup");
      if (this.selectedCategory.isAddSubCategory == true) {
        this.addAlbum = true;
      }
    },
    async getCategories() {
      const getCategory = await this.$store.dispatch(
        "baseAdminCategory/getCategoryData"
      );
      if (getCategory && getCategory.code === 200) {
        this.categoriesOption = getCategory.data.data.result;
        console.log(this.categoriesOption, "categories");
      }
    },
  },
  async mounted() {
    console.log("New album called");
    console.log(
      (this.ruleForm.categoriesIds[0] = this.selectedCategory._id),
      "this"
    );
    this.ruleForm.categoriesIds[0] = this.selectedCategory._id;
    await this.openAddAlbumPopup();
    await this.getCategories();
    await this.getSubcategory();
  },
};
</script>
<style>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
.draggable-item {
  margin-bottom: 10px;
  cursor: move;
  transition: transform 0.3s ease-in-out;
}

.custh24 .el-upload-dragger {
  height: 84px !important;
}

.custuploadicon.el-upload-dragger .el-icon-upload {
  font-size: 32px !important;
  line-height: 2px !important;
}
</style>
